<template>
    <div class="ma-3 step-action">
    <v-toolbar>
        <v-toolbar-title>Connect Device</v-toolbar-title>
    </v-toolbar>
        <v-card>
            <v-layout row wrap>
                <v-flex sm7 xs12>
            <v-card-text>
                <v-layout column>
                    <v-flex>
                    <ol class="ma-4 instruction-ol">
                        <li>Enable Switch RCM</li>
                        <li>Connect Switch via USB</li>
                        <li>Click the button below</li>
                        <li>Select device 'APX'</li>
                    </ol>
                    </v-flex>
                    <v-flex>
                        <v-btn color="info"
                               block
                               :loading="connectingDevice"
                               :disabled="disableRequestDeviceAccessButton"
                               @click.native="requestDeviceAccess">
                            Request Device Access
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-card-text>
                </v-flex>
                <v-flex>
                    <device-info/>
                </v-flex>
            </v-layout>
        </v-card>
    </div>
</template>
<script>
import DeviceInfo from "./DeviceInfo.vue";
import { mapGetters, mapState } from "vuex";

export default {
  name: "connect-device",
  components: { DeviceInfo },
  methods: {
    requestDeviceAccess() {
      this.$store.dispatch("requestDeviceAccess");
    }
  },
  computed: {
    ...mapGetters(["working"]),
    ...mapState(["connectingDevice", "device", "deviceId"]),
    disableRequestDeviceAccessButton() {
      return this.working || (this.device !== null && this.deviceId !== null);
    }
  }
};
</script>
<style>
.instruction-ol li {
  height: 40px;
}

.step-action {
  min-height: 320px;
}
</style>
